import * as yup from 'yup';

export const validationSchema = yup.object({
  initials: yup.string().required('Il campo è obbligatorio'),
  type: yup.string().required('Il campo è obbligatorio'),
  description: yup.string().required('Il campo è obbligatorio'),
});
